import { Component, OnInit } from '@angular/core';
import { UxService } from '~/app/core/services/ux.service';
import { ValidationService } from '~/app/core/services/validation.service';
import { Link } from '~/app/open-age/core/structures';
import { NavService } from '~/app/core/services';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-log-view',
  templateUrl: './log-view.component.html',
  styleUrls: ['./log-view.component.css']
})
export class LogViewComponent implements OnInit {

  isProcessing: boolean;
  id: string;
  isCurrent = true;
  page: Link;

  constructor(
    private errorHandler: UxService,
    private validator: ValidationService,
    private navService: NavService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.page = this.navService.register(`/log/list/:id`, this.route, (isCurrent, params) => {
      this.id = params.get("id")
      this.isCurrent = isCurrent;
      if (this.isCurrent) {
        this.setContext();
      }
    });
  }

  setContext() {
  }

  back() {
    this.navService.goto("/log/list")
  }

}
